var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._g(_vm._b({staticClass:"dataset-body-loading",class:[_vm.data.staticClass, _vm.props.class]},'div',_vm.data.attrs,false),_vm.listeners),[(_vm.slots().default)?_vm._t("default"):_c('span',[_vm._v("loading")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }